import type { FieldError } from 'react-hook-form'

export default function BusinessFormErrorMessage({ error }: { error: FieldError }) {
  return <div className="text-red-500">{error?.message}</div>
}
